import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import c from "highlight.js/lib/languages/c";
import cpp from "highlight.js/lib/languages/cpp";
import cs from "highlight.js/lib/languages/csharp";
import css from "highlight.js/lib/languages/css";
import diff from "highlight.js/lib/languages/diff";
import html from "highlight.js/lib/languages/haml";
import java from "highlight.js/lib/languages/java";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import php from "highlight.js/lib/languages/php";
import plaintext from "highlight.js/lib/languages/plaintext";
import python from "highlight.js/lib/languages/python";
import ruby from "highlight.js/lib/languages/ruby";
import typescript from "highlight.js/lib/languages/typescript";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";
import "highlight.js/styles/github-dark.css";
import { useEffect } from "react";
import "./codeBlock.scss";

const LANGUAGE_ALIASES = [
  ["plaintext", plaintext],
  ["bash", bash],
  ["c", c],
  ["cpp", cpp],
  ["cs", cs],
  ["css", css],
  ["diff", diff],
  ["html", html],
  ["java", java],
  ["javascript", javascript],
  ["json", json],
  ["php", php],
  ["python", python],
  ["ruby", ruby],
  ["typescript", typescript],
  ["xml", xml],
  ["yaml", yaml],
];

let languagesRegistered = false;

function registerLanguages() {
  if (languagesRegistered) return;
  LANGUAGE_ALIASES.forEach(([name, language]) => {
    hljs.registerLanguage(name, language);
  });
  languagesRegistered = true;
}

function attachCopyButton(preElement, codeElement) {
  if (preElement.querySelector(".manual-code-copy-button")) return;

  const copyButton = document.createElement("button");
  copyButton.type = "button";
  copyButton.className = "manual-code-copy-button";
  copyButton.textContent = "Copy";

  copyButton.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(codeElement.textContent ?? "");
      copyButton.textContent = "Copied!";
      copyButton.classList.add("copied");
      window.setTimeout(() => {
        copyButton.textContent = "Copy";
        copyButton.classList.remove("copied");
      }, 1200);
    } catch (_error) {
      copyButton.textContent = "Failed";
      window.setTimeout(() => {
        copyButton.textContent = "Copy";
      }, 1200);
    }
  });

  preElement.classList.add("manual-code-block");
  preElement.appendChild(copyButton);
}

/**
 * 컨테이너 내 CKEditor 코드 블록에 구문 강조와 복사 버튼을 적용한다.
 * @param {HTMLElement | null | undefined} container
 */
export function enhanceCodeBlocks(container) {
  if (!container) return;

  registerLanguages();

  container.querySelectorAll("pre code").forEach((codeElement) => {
    if (!codeElement.classList.contains("hljs")) {
      hljs.highlightElement(codeElement);
    }

    const preElement = codeElement.closest("pre");
    if (preElement) {
      attachCopyButton(preElement, codeElement);
    }
  });
}

/**
 * ref가 가리키는 컨테이너의 코드 블록에 highlight/copy를 적용한다.
 * @param {import("react").RefObject<HTMLElement>} containerRef
 * @param {*} content 트리거용 의존값 (매뉴얼 HTML)
 * @param {*} display 트리거용 의존값 (노출 여부)
 */
export function useEnhanceCodeBlocks(containerRef, content, display) {
  useEffect(() => {
    enhanceCodeBlocks(containerRef.current);
  }, [containerRef, content, display]);
}
